var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-0 data-field-panel"},[_c('v-col',{staticClass:"text-end font-weight-bold data-field-panel__ttl",attrs:{"cols":"12","sm":"4"}},[(!!_vm.label)?_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()]),_c('v-col',{staticClass:"data-field-panel__txt",attrs:{"cols":"12","sm":"8"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }